import { render, staticRenderFns } from "./StoreTags.vue?vue&type=template&id=7f0feac4&"
import script from "./StoreTags.vue?vue&type=script&lang=js&"
export * from "./StoreTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports